import { COLORS } from "../Global/materials";
import { POLYGONS } from "../Global/variables";
import { setPanelWireframeStyle } from "./Helpers";
import { panelInSegment } from "./Placement";

export function refreshPanelOverlapHighlights(segmentIndices = null) {
  const indices = normalizeSegmentIndices(segmentIndices);
  indices.forEach((segmentIndex) => refreshSegmentPanelOverlapHighlights(segmentIndex));
}

export function refreshSegmentPanelOverlapHighlights(segmentIndex) {
  if (!Number.isInteger(segmentIndex) || segmentIndex < 0) return;
  const segment = POLYGONS?.[segmentIndex];
  const panels = Array.isArray(segment?.panels) ? segment.panels : [];

  panels.forEach((panelData) => {
    const panelMesh = panelData?.panel;
    if (!panelMesh) return;

    // Preserve explicit selection outline while still validating non-selected panels.
    if (panelMesh?.userData?.isSelected === true) {
      setPanelWireframeStyle(panelMesh, { opacity: 1, color: COLORS.yellow });
      return;
    }

    const isValid = panelInSegment(panelMesh, segmentIndex);
    if (!isValid) {
      setPanelWireframeStyle(panelMesh, { opacity: 1, color: COLORS.red });
      return;
    }

    setPanelWireframeStyle(panelMesh, { opacity: 0, color: COLORS.red });
  });
}

function normalizeSegmentIndices(segmentIndices) {
  if (segmentIndices == null) {
    return POLYGONS.map((_, idx) => idx);
  }

  if (Array.isArray(segmentIndices)) {
    return [...new Set(segmentIndices)]
      .map((idx) => Number(idx))
      .filter((idx) => Number.isInteger(idx) && idx >= 0 && idx < POLYGONS.length);
  }

  const idx = Number(segmentIndices);
  if (!Number.isInteger(idx) || idx < 0 || idx >= POLYGONS.length) return [];
  return [idx];
}
